// Polyfills
import 'react-app-polyfill/stable';

// CSS
import '@amzn/awsui-global-styles/polaris.css';

// Disables XB's token refresh to prevent 403 errors on /refreshToken calls. This package
// doesn't ever need to refresh the auth token, and by default XB framework tries to refresh
// tokens on load. The issue with this is that it gives misleading network errors upon customer
// inspection/engineer investigation. These aren't *really* errors from Gandalf's view.
// This "special magic" value MUST be set before @amzn/aws-tc-xb-root-utils (ExperienceBridge) is imported.
// Search this value in Experience package for an explaination of "how" it's used. Hehe.
(window as any).xbDisableTokenRefresh = true;
